import { AppServices } from "../../../AppServices";
import { TeamRole, UserCapabilities } from "../../../store/Models/UserContext";
import { ToxnotComponent } from "./ToxnotComponent";
import { ToxnotComponentProperties } from "./ToxnotComponent";

// ===============================================================================

//
// Components that need the user to be signed in to use must inherit from this abstract class.
// Concrete subclass must also override renderConcreteComponent to display their contents. 
// The normal render method is used to check if the user is signed in, returning null 
// they are not.
//
export abstract class ToxnotSignInRequiredComponent<P extends ToxnotComponentProperties, S = {}, SS = any> extends ToxnotComponent<P, S, SS> {

    // ===============================================================================

    public render() {
        if (this.props.appServices.userContext === null) {
            AppServices.redirectToSignInPage();
            return null;
        }

        if (this.getDisallowedRoles().includes(this.props.appServices.userContext.role)) {
            // do something to show that they aren't allowed to access this page.
            AppServices.redirectToGetStarted();
            return null;
        }
        
        return this.renderConcreteComponent();
    }

    // ===============================================================================
    
    protected abstract getDisallowedRoles(): TeamRole[];
    
    // ===============================================================================

    protected getUserContextForSignedInUser() {
        if (this.props.appServices.userContext === null) {
            throw new Error("User Context was null. You can only get the user context for signed in users");
        }

        return this.props.appServices.userContext;
    }

    // ===============================================================================

    protected getUserCapabilities(): UserCapabilities {
        if (this.props.appServices.userContext === null) {
            throw new Error("User Context was null. You can only get the user context for signed in users");
        }

        return this.props.appServices.userContext.userCapabilities;
    }

    // ===============================================================================

    protected abstract renderConcreteComponent(): JSX.Element | null;
}
